export const USER = {
    API: 'User'
}

export const USERAPIConstant = {
    GETPLANTLIST: USER.API + '/Validate',
    ADDMAINTAINENCEUSERRECORD: USER.API + '/AddMaintainenceUserRecord',
    VALIDATEUSER : USER.API + '/userdetails',
}